import styled from 'styled-components';
import { IoIosArrowBack } from 'react-icons/io';
import { RootState } from '../../../store/modules';
import { useDispatch, useSelector } from 'react-redux';
import { BsLayoutSidebarReverse } from 'react-icons/bs';
import { setTabletNavSidebarOpenState } from '../../../store/modules/tabletNavSidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserInfo } from '../../userHeader/UserInfo';
import { useEffect, useMemo } from 'react';
import { categoryMap, HeaderDataType } from '../../../@const/headerData';

const pathTree: Record<string, any> = {
  home: {},
  'production-progress-tablet': {
    parent: 'home',
    children: {
      'production-progress-tablet/:productionId/:itemId': {
        parent: 'production-progress-tablet',
      },
    },
  },
  'production-bom': {
    parent: 'home',
    children: {
      'production-bom/:workbayId/:itemId': {
        parent: 'production-bom',
      },
    },
  },
  'delivery-schedule': {
    parent: 'home',
  },
};

export const TabletHeader = () => {
  const tableHeaderTextItems = useSelector(
    (state: RootState) => state.tabletNavHeader
  );

  const tabletSidebarOpenState = useSelector(
    (state: RootState) => state.tabletNavSidebar.openState
  );

  const location = useLocation();

  const currentPath = '/' + location.pathname.split('/').slice(1).join('/');

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const matchPath = (path: string, template: string): boolean => {
    if (!path || !template) return false;
    const pathSegments = path.split('/').filter(Boolean);
    const templateSegments = template.split('/').filter(Boolean);

    if (pathSegments.length !== templateSegments.length) return false;

    return templateSegments.every(
      (segment, index) =>
        segment.startsWith(':') || segment === pathSegments[index]
    );
  };

  const findParentPath = (
    currentPath: string,
    pathTree: Record<string, any>
  ): string | null => {
    const search = (tree: Record<string, any>): string | null => {
      for (const [key, value] of Object.entries(tree)) {
        if (matchPath(currentPath, key)) {
          return value.parent || null;
        }
        if (value.children) {
          const found = search(value.children);
          if (found) return found;
        }
      }
      return null;
    };
    return search(pathTree);
  };

  const getParentPath = (currentPath: string): string => {
    const parentPath = findParentPath(currentPath, pathTree);
    return parentPath || '/home';
  };

  useEffect(() => {
    if (!currentPath) return;
    const headerData = categoryMap[currentPath] as HeaderDataType;
  }, [currentPath]);

  const goBack = () => {
    const parentPath = '/' + getParentPath(currentPath);
    navigate(parentPath);
  };

  return (
    <Container className='tablet-header'>
      <Section className='row-justify-start flex-gap-0dot5rem'>
        <div
          style={{ display: 'flex', gap: '7px', alignItems: 'center' }}
          onClick={() => goBack()}
        >
          <IoIosArrowBack />

          <Text>뒤로가기</Text>
        </div>
      </Section>
      <Section className='row-justify-center'>
        <Text>{tableHeaderTextItems.workbayName}</Text>
      </Section>
      <Section className='row-justify-end flex-gap-0dot5rem'>
        <Text>{tableHeaderTextItems.timeDate}</Text>
        <div style={{ height: '30px' }}>
          <UserInfo />
        </div>
        <BsLayoutSidebarReverse
          size={20}
          onClick={() =>
            dispatch(setTabletNavSidebarOpenState(!tabletSidebarOpenState))
          }
        />
      </Section>
    </Container>
  );
};

const Container = styled.div`
  margin: 0px 2rem;
  display: flex;
  flex: 0 0 40px;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => `${theme.colors.charcoal}`};
  z-index: 999;
`;

const Section = styled.div`
  display: flex;
  flex-basis: 33%;
  align-items: center;
`;

const Text = styled.div`
  color: #777777;
`;
